import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingRoutingModule } from './home-routing.module';
import { TrainingTracksComponent } from '../components/training-tracks/training-tracks.component';
import { OurTeamComponent } from '../components/our-team/our-team.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from 'src/app/shared/shared.module';
import { MainSliderComponent } from '../components/main-slider/main-slider.component';
import { RecordedCoursesComponent } from '../components/recorded-courses/recorded-courses.component';
import { LiveCoursesComponent } from '../components/live-courses/live-courses.component';
import { PartnersComponent } from '../components/partners/partners.component';
import { TrainingCentersComponent } from '../components/training-centers/training-centers.component';
import { InstructorsComponent } from '../components/instructors/instructors.component';
import { MiddleBannerComponent } from '../components/middle-banner/middle-banner.component';
import { TestimonialsComponent } from '../components/testimonials/testimonials.component';
import { HomePageComponent } from '../components/home-page/home-page.component';
import { AdvertisementsComponent } from '../components/advertisements/advertisements.component';
import { CounterComponent } from '../components/counter/counter.component';
import { CourseSharedModule } from 'src/app/course/course-shared.module';

@NgModule({
  declarations: [
    TrainingTracksComponent,
    OurTeamComponent,
    AdvertisementsComponent,
    HomePageComponent,
    MainSliderComponent,
    RecordedCoursesComponent,
    CounterComponent,
    LiveCoursesComponent,
    PartnersComponent,
    TrainingCentersComponent,
    InstructorsComponent,
    MiddleBannerComponent,
    TestimonialsComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingRoutingModule,
    TranslateModule,
    NgxPermissionsModule,
    SharedModule,
    CourseSharedModule
  ],
  exports: [
    OurTeamComponent
  ]
})
export class HomeModule { }
